<template>
  <div class="topic" @click="handleTopicSelect">
    <h6 class="title">
      {{ index + 1 }}.
    </h6>
    <div ref="topic" />
  </div>
</template>
<script>
// import TkSdk from '@aixuexi/tksdk'
import '@aixuexi/tksdk/build/main.css'
// import videoService from '@/service/video/index'
export default {
  props: {
    topic: {
      type: Object
    },
    index: {
      type: Number
    },
    render: {
      type: Function
    }
  },
  methods: {
    handleTopicSelect() {
      this.$emit('topic-select', this.topic, this.index)
    },
    renderTopic() {
      const result = this.render(this.topic)

      const resultHtml = result.TPL.getStructure()

      const div = document.createElement('div')
      div.appendChild(resultHtml.tiGan)
      resultHtml.options && div.appendChild(resultHtml.options)
      const ui = document.createElement('ul')
      div.appendChild(ui)
      resultHtml.childs && resultHtml.childs.forEach(i => {
        const li = document.createElement('li')
        li.appendChild(i.tiGan)
        i.options && li.appendChild(i.options)
        ui.appendChild(li)
      })

      this.$refs.topic.appendChild(div)
    }
  },
  mounted() {
    this.renderTopic()
    if (this.index === 0) {
      this.handleTopicSelect()
    }
  }
}
</script>
<style lang="less" scoped>
  .topic{
    cursor: pointer;
    display: flex;
    flex-direction: row;
    .title{
      padding-left: 10px;
      margin: 0;
    }
    :deep(.topic-render-container){
      width: 100%;
      .tr-video-jx{
        width: 100%;
        height: auto;
      }
    }
  }
</style>